<script>

const moment = require('moment');

export default {

    name: 'item-status',
    props: [ 'item' ],
    data() {
        return {
            data: {
                'set_qrcode_position' : { variant: 'secondary', label: 'Qr code' },
                'sent'                : { variant: 'info',      label: 'inviato' },
                'saved'               : { variant: 'primary',   label: 'salvato' },
                'notarized'           : { variant: 'warning',   label: 'OK'      },
                'error'               : { variant: 'danger',    label: 'error'   },
            }
        }
    },
    computed: {
        variant() { return this.data[ this.item.config.status ].variant },
        label() { return this.data[ this.item.config.status ].label },
    },
    methods: {},
    created() {},

}

</script>

<template>

    <b-badge :variant="variant">{{ label }}</b-badge>

</template>


